import React from "react";

import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "material-ui/Dialog";
import { CircularProgress } from "material-ui/Progress";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";

const styles = theme => ({
  dialogContent: {
    minWidth: 500,
    maxWidth: 600,
    border: "none"
  },
  contentText: {
    whiteSpace: "pre-line"
  },
  cautionBtn: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light
    }
  },
  buttonProgress: {
    color: "#007eff",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
    minWidth: 24
  }
});

const mobileStyles = () => ({
  dialogTitle: {
    padding: 10
  },
  dialogActions: {
    margin: 5
  }
});

class CompleteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spin: false
    };
  }
  render() {
    const { props } = this;
    const { completeDialog, classes } = props;

    return (
      <Dialog
        disableBackdropClick
        open={completeDialog.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogTitle}>
          {completeDialog.title}
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.contentText}
          >
            {completeDialog.contentText}
          </DialogContentText>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            disabled={this.state.spin}
            raised={!isMobile.any}
            onClick={() => {
             completeDialog.handleCloseClick();
           }}
          >
            {completeDialog.btnCancelLabel}
          </Button>
          <div style={{ position: "relative" }}>
            <Button
              disabled={this.state.spin}
              raised={!isMobile.any}
              className={completeDialog.caution ? classes.cautionBtn : ""}
              onClick={() => {
               completeDialog.handleOpenClick();
             }}
              style={{ width: "100%" }}
            >
              {completeDialog.btnOKLabel}
            </Button>
            {this.state.spin && (
            <CircularProgress size={24} className={classes.buttonProgress} />
           )}
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : styles)(CompleteDialog);



// WEBPACK FOOTER //
// ./src/components/CompleteDialog.jsx